/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var CloseFilled = defineComponent({
  name: "CloseFilled",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
CloseFilled.install = function (app) {
  app.component(CloseFilled.name, CloseFilled);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24ZM26.4589 23.9994L32.6083 17.8512L30.1488 15.3917L23.9994 21.5399L17.8512 15.3917L15.3917 17.8512L21.5399 23.9994L15.3917 30.1488L17.8512 32.6083L23.9994 26.4589L30.1488 32.6083L32.6083 30.1488L26.4589 23.9994Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

CloseFilled.render = render;

export { CloseFilled as default };
